import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { commercialConstants } from '../../../../common/commercial-constants';

@Component({
    selector: 'is-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    standalone: false
})
export class AddressComponent implements OnInit {
    @Input() addressHeader: string;
    @Input() fieldNameSpace: string;
    @Input() lineOfBusiness: string;
    @Input() parentForm: UntypedFormGroup;

    address: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(/^[a-zA-Z0-9#,-./ ]*$/)]);
    addressForm: UntypedFormGroup;
    americanStates = commercialConstants.states;
    city: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(/^[a-zA-Z,-. ]*$/)]);
    countries: string[] = ['United States', 'Canada', 'Mexico', 'Puerto Rico', 'Other'];
    country: UntypedFormControl = new UntypedFormControl('United States');
    currentStatesList = this.americanStates;
    mexicanStates: string[] = ['Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas', 'Chihuahua',
        'Coahuila', 'Colima', 'Distrito Federal', 'Durango', 'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco', 'Michoacán',
        'Morelos', 'México', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosi',
        'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'];
    otherStateProvince: UntypedFormControl = new UntypedFormControl('', Validators.required);
    postalCode: UntypedFormControl = new UntypedFormControl('', Validators.required);
    province: UntypedFormControl = new UntypedFormControl('', Validators.required);
    provinces: string[] = ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
        'Newfoundland and Labrador', 'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan'];
    state: UntypedFormControl = new UntypedFormControl('', Validators.required);
    zip: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(/^[0-9]{5}(-[0-9]{4})?$/)]);

    constructor(private formBuilder: UntypedFormBuilder) { }
    buildForm(): void {
        // Need to add new regex validations for claims fields
        this.parentForm.addControl('addressGroup', this.addressForm = this.formBuilder.group({
            address: this.address,
            city: this.city,
            state: this.state,
            country: this.country,
            province: this.province,
            postalCode: this.postalCode,
            zip: this.zip,
            otherStateProvince: this.otherStateProvince
        }));
        this.province.disable();
        this.postalCode.disable();
        this.otherStateProvince.disable();
    }

    ngOnInit(): any {
        this.buildForm();
        this.country.valueChanges.subscribe((value) => {
            switch (value) {
                case 'Mexico': {
                    this.currentStatesList = this.mexicanStates;
                    this.setMexicoControls();
                    break;
                }
                case 'United States': {
                    this.currentStatesList = this.americanStates;
                    this.setUnitedStatesControls();
                    break;
                }
                case 'Canada': {
                    this.setCanadaControls();
                    break;
                }
                case 'Puerto Rico': {
                    this.setPuertoRicoControls();
                    break;
                }
                case 'Other': {
                    this.setOtherCountryControls();
                    break;
                }
                // No default
            }
            this.addressForm.updateValueAndValidity();
        });
    }

    resetLocation(): void {
        this.addressForm.patchValue({
            address: '',
            city: '',
            state: '',
            province: '',
            postalCode: '',
            zip: '',
            otherStateProvince: ''
        });
        this.addressForm.markAsUntouched();
        this.addressForm.markAsPristine();
    }
    setCanadaControls(): void {
        this.postalCode.setValidators([Validators.required,
        Validators.pattern(/^[a-zA-Z][0-9][a-zA-Z] [0-9][a-zA-Z][0-9]$/)]);
        this.province.enable();
        this.postalCode.enable();
        this.state.disable();
        this.zip.disable();
        this.otherStateProvince.disable();
    }

    setMexicoControls(): void {
        this.postalCode.setValidators([Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{0,15}$/)]);
        this.state.enable();
        this.postalCode.enable();
        this.province.disable();
        this.zip.disable();
        this.otherStateProvince.disable();
    }

    setOtherCountryControls(): void {
        this.postalCode.setValidators([Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{0,15}$/)]);
        this.otherStateProvince.enable();
        this.postalCode.enable();
        this.zip.disable();
        this.state.disable();
        this.province.disable();
    }

    setPuertoRicoControls(): void {
        this.zip.setValidators([Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{0,15}$/)]);
        this.zip.enable();
        this.state.disable();
        this.province.disable();
        this.postalCode.disable();
        this.otherStateProvince.disable();
    }

    setUnitedStatesControls(): void {
        this.zip.setValidators([Validators.required,
        Validators.pattern(/^[0-9]{5}(-[0-9]{4})?$/)]);
        this.state.enable();
        this.zip.enable();
        this.province.disable();
        this.postalCode.disable();
        this.otherStateProvince.disable();
    }
}
